<template>
  <complaint-list
    mode="index"
    api-url="complaints"
    title="Complaints"
    subtitle="Review every client complaint, send it for initial handling and verify it once resolved."
    icon="AlertOctagonIcon"
  />
</template>

<script>
import ComplaintList from './ComplaintList.vue'

export default {
  components: { ComplaintList },
}
</script>
